<script>
    export let number;
    export let type = "decimal";
    export let locale = "fr";
    export let noZero = false;

    let formattedNumber = new Intl.NumberFormat(locale, {
        style: type,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(number);

    if (noZero && (number === 0 || number === 0.0)) {
        formattedNumber = "";
    }
</script>

<span>{formattedNumber}</span>

<style>
    span {
        font-variant-numeric: tabular-nums;
    }
</style>
